import Cookies from "js-cookie";

const safeEncode = (str) => btoa(encodeURIComponent(str));
const safeDecode = (str) => decodeURIComponent(atob(str || ""));

const AuthReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN": {
      const token = action.payload?.token ?? null;
      const refreshToken = action.payload?.refreshToken ?? null;
      const user = action.payload?.account ?? action.payload?.user ?? null;

      // Lưu cookies
      if (token) Cookies.set("token", token, { expires: 7 });
      else Cookies.remove("token");

      if (refreshToken) {
        Cookies.set("refreshToken", refreshToken, { expires: 30 });
      } else {
        Cookies.remove("refreshToken");
      }

      if (user) {
        const encodedUser = safeEncode(JSON.stringify(user));
        Cookies.set("user", encodedUser, { expires: 7 });
      } else {
        Cookies.remove("user");
      }

      return {
        token: token,
        refreshToken: refreshToken,
        user: user,
      };
    }

    case "REFRESH_TOKEN": {
      // Action để update token khi refresh
      const token = action.payload?.token ?? null;
      const refreshToken = action.payload?.refreshToken ?? state.refreshToken;

      if (token) {
        Cookies.set("token", token, { expires: 7 });
      } else {
        Cookies.remove("token");
      }

      // Cập nhật refreshToken nếu có
      if (refreshToken) {
        Cookies.set("refreshToken", refreshToken, { expires: 30 });
      }

      return {
        ...state,
        token: token,
        refreshToken: refreshToken,
      };
    }

    case "UPDATE_USER_INFO": {
      const user = action.payload?.user ?? null;
      if (user) {
        const encoded = safeEncode(JSON.stringify(user));
        Cookies.set("user", encoded, { expires: 7 });
      } else {
        Cookies.remove("user");
      }
      return {
        ...state,
        user: user,
      };
    }

    case "LOGOUT": {
      Cookies.remove("token");
      Cookies.remove("refreshToken");
      Cookies.remove("user");
      return { token: null, refreshToken: null, user: null };
    }

    default:
      return state;
  }
};

export default AuthReducer;
